<template>
    <section>
        <PageTitle title="New Delivery Order" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/new_delivery_order',title:'New Delivery Order'}]" />
        <div class="wrapper wrapper-content">
            <div class="row">
                <div class="col-md-12">
                    <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                        <div class="sk-bounce1"></div>
                        <div class="sk-bounce2"></div>
                        <div class="sk-bounce3"></div>
                    </div>
                    <ul class="list-inline" v-if="userRole !== 'ROLE_USER'" >
                        <li v-for="orderSource in orderSources" :key="orderSource.id">
                            <div class="" >
                                <label>
                                    <input type="radio" :id="orderSource.id" v-model="newOrderType"  :value="orderSource.id" :name="orderSource.source"> {{orderSource.source}}
                                </label>
                            </div>
                        </li>
                    </ul>
                    <form method="post" @submit.prevent="makeNewOrderRequest()">
                        <div class="form-group">
                            <div class="input-group">
                                <input v-model="callerNumber" v-on:keyup="validateContactNumber($event)" required="required" placeholder="03xxxxxxxxx or 04xxxxxxxx" type="text" class="form-control callerNumberBox">
                                <span class="input-group-btn">
                                    <button type="submit" class="btn btn-primary"><b><i class="fa fa-search"></i></b></button>
                                </span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row" v-if="Object.keys(order).length > 0">
                <div v-if="newOrderType === 7 || (order.orderSource && order.orderSource.id === 7)" class="col-lg-4">
                    <div class="ibox-title">
                        <h5 class="pull-left">
                            <strong class="text-success">
                                Foodpanda Details
                            </strong>
                        </h5>
                        <span class="pull-right">
                            <a class="myTip_foodpanda_section" title="Save Details" v-on:click="updateOrderFoodpandaDetails()"><b class="fa fa-save"></b></a>
                        </span>
                    </div>
                    <div class="ibox-content c2d_cont_1">
                        <div class="row" style="margin-bottom: 5px">
                            <div class="form-group" style="padding-left: 10px; padding-right: 5px">
                                <label class="col-sm-3 col-form-label"
                                       style="padding-top: 10px"
                                >
                                    Customer Name
                                </label>
                                <div class="col-sm-9">
                                    <input v-model="order.foodPandaDetails.customerName"
                                           type="text"
                                           class="form-control"
                                           required="required"
                                           placeholder="Customer Name..."/>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom: 5px">
                            <div class="form-group" style="padding-left: 10px; padding-right: 5px">
                                <label class="col-sm-3 col-form-label"
                                       style="padding-top: 10px"
                                >
                                    Order Id
                                </label>
                                <div class="col-sm-9">
                                    <input v-model="order.foodPandaDetails.foodPandaOrderId"
                                           type="text"
                                           class="form-control"
                                           required="required"
                                           placeholder="Foodpanda Order Id..."/>
                                </div>
                            </div>
                        </div>
<!--                        <br/><br/><br/>-->
                    </div>
                </div>
                <div v-else class="col-lg-4">
                    <div v-if="customerBlocked" class="blocking_overlay text-center"><i class="fa fa-ban"></i></div>
                    <div class="ibox-title">
                        <h5 class="pull-left">
                            <strong v-if="!customerBlocked" class="text-success">{{order.customerAddressesByCustomerAddressId.customersByCustomerId.name}}<small v-if="order.orderTypesByOrderTypeId.id!==1"> - Distance: <b class="badge badge-primary">{{order.totalDistance / 2}} Km</b></small></strong>
                            <strong v-else class="text-danger">{{order.customerAddressesByCustomerAddressId.customersByCustomerId.name}} - <small>BLOCKED</small></strong>
                        </h5>
                        <span class="pull-right">
                            <a class="myTip_address_section" title="Add New Address" v-on:click="openCustomerAddressModal(-1)"><b class="fa fa-plus"></b></a> |
                            <a class="myTip_address_section" title="Update Customer" v-on:click="openCustomerInformationModal()"><b class="fa fa-pencil"></b></a>
                        </span>
                    </div>
                    <div class="ibox-content c2d_cont_1">
                        <div class="row" style="margin-bottom: 5px">
                            <div class="col-md-4">
                                <b class="cartTip" title="Contact - 1">{{(order.customerAddressesByCustomerAddressId.customersByCustomerId.contact1 === null) ? 'N/A' : order.customerAddressesByCustomerAddressId.customersByCustomerId.contact1}}</b>
                            </div>
                            <div class="col-md-4 text-center">
                                 <b class="cartTip" title="Contact - 2">{{(order.customerAddressesByCustomerAddressId.customersByCustomerId.contact2 === null) ? 'N/A' : order.customerAddressesByCustomerAddressId.customersByCustomerId.contact2}}</b>
                            </div>
                            <div class="col-md-4 text-right">
                                 <b class="cartTip" title="Contact - 3">{{(order.customerAddressesByCustomerAddressId.customersByCustomerId.contact3 === null) ? 'N/A' : order.customerAddressesByCustomerAddressId.customersByCustomerId.contact3}}</b>
                            </div>
                        </div>
                        <div class="text-center text-danger" style="padding-top:30px;" v-if="parseInt(order.orderTypesByOrderTypeId.id)===1">
                            <h2><strong>This is Take Away Order</strong></h2>
                        </div>
                        <div class="row" v-else>
                            <div class="col-md-12">
                                <ul class="list-group" id="customer_address_section" v-if="order.customerAddressesByCustomerAddressId!==null">
                                    <li class="list-group-item" v-for="(address, index) in customerAddresses" v-if="!address.deleted && address.areasByAreaId.id!==$store.state.takeAwayAddressId" v-bind:key="'address_' + index">
                                        <a target="_blank" class="pull-right myTip_address_section" title="View On Map" v-bind:href="'https://www.google.com/maps/place/'+address.areasByAreaId.lat+','+address.areasByAreaId.lng"><i class="fa fa-map-marker"></i></a>
                                        <div class="i-checks">
                                            <label style="cursor: pointer" v-on:click="updateNewAddressOfCustomer(address.id, address.areasByAreaId.citiesByCityId.id)">
                                                <input type="radio"  v-model="order.customerAddressesByCustomerAddressId.id" v-bind:value="address.id" name="address">
                                                {{ (address.address + ', ' + address.areasByAreaId.name + ', ' + address.areasByAreaId.citiesByCityId.city) }}
<!--                                                {{ ( (address.address + ', ' + address.areasByAreaId.name + ', ' + address.areasByAreaId.citiesByCityId.city).length > 40 ) ?-->
<!--                                                (address.address + ', ' + address.areasByAreaId.name + ', ' + address.areasByAreaId.citiesByCityId.city).substring(0, 40) + '...' :-->
<!--                                                (address.address + ', ' + address.areasByAreaId.name + ', ' + address.areasByAreaId.citiesByCityId.city) }}-->
                                            </label>
                                            <!--<a v-if="!(order.customerAddressesByCustomerAddressId.id === address.id)" class="btn btn-xs btn-link myTip_address_section" title="Edit Address" v-on:click="openCustomerAddressModal(address.id)"> - <i class="fa fa-pencil"></i></a>-->
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="ibox-title">
                        <select class="pull-left" v-on:change="changeBranchOfNewOrder(false, order.orderTypesByOrderTypeId.id)" v-model="order.branchesByBranchId.id" style="background: #FFFFFF">
                            <option v-for="branch in allBranches" v-bind:key="branch.id+'_branch'" v-bind:value="branch.id">{{branch.areasByAreaId.name}}</option>
                        </select>
                        <span class="pull-right" v-if="order.orderTypesByOrderTypeId.id!==1">
                            <a v-on:click="changeBranchOfNewOrder(true, orderTypeId)">Optimize</a>
                        </span>
                    </div>
                    <div class="ibox-content c2d_cont_1">
                        <address>
                            <div class="row">
                                <div class="col-md-12">
                                    <strong class="text-success ">
                                        {{order.branchesByBranchId.restaurantsByRestaurantId.name}}, {{order.branchesByBranchId.areasByAreaId.name}}, {{order.branchesByBranchId.areasByAreaId.citiesByCityId.city}}
                                        <b v-if="punchDisabled" class="text-danger"> - Closed</b>
                                        <b v-if="!deliveryEnabled" class="text-danger"> - Delivery Not Available</b>
                                        <b v-if="!pickupEnabled" class="text-danger"> - Pickup Not Available</b>
                                    </strong>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4"><b class="cartTip" title="Contact - 1">{{(order.branchesByBranchId.phone1 === null || order.branchesByBranchId.phone1 === "") ? 'N/A' : order.branchesByBranchId.phone1}}</b></div>
                                <div class="col-md-4 text-center"><b class="cartTip" title="Contact - 2">{{(order.branchesByBranchId.phone2 === null || order.branchesByBranchId.phone2 === "") ? 'N/A' : order.branchesByBranchId.phone2}}</b></div>
                                <div class="col-md-4 text-right"><b class="cartTip" title="Contact - 3">{{(order.branchesByBranchId.phone3 === null || order.branchesByBranchId.phone3 === "") ? 'N/A' : order.branchesByBranchId.phone3}}</b></div>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="col-md-6">
                                    Radius: <b>{{order.branchesByBranchId.deliveryRadius}} Km</b>
                                </div>
                                <div class="col-md-6 pull-right">
                                    Min. Order: <b>{{order.branchesByBranchId.minimumOrder}} Rs</b>
                                </div>
                            </div>
                            <br/>
                            <div class="row">
                                <div class="col-md-6">
                                    Tax Amount: <b>{{order.branchesByBranchId.tax}} %</b>
                                </div>
                                <div class="col-md-6 pull-right">
                                    <BranchTimings v-bind:timings="order.branchesByBranchId.timings" />
                                </div>
                            </div>
                        </address>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="ibox-title">
                        <h5 class="pull-left">Order History Of Customer</h5>
                    </div>
                    <div class="ibox-content c2d_cont_1">
                        <table class="table table-striped table-responsive table-bordered">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Billed Price</th>
                                    <th>Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="white-space: nowrap" v-for="(orderHis, index) in customerOrderHistory" v-bind:class="(orderHis.complainCount > 0) ? 'danger' : ''" v-bind:key="index+'_orderHis'">
                                    <td><a v-on:click="openOrderDetailModal(orderHis.orderId)">{{orderHis.orderId}}</a></td>
                                    <td>{{orderHis.billedPrice}} Rs.</td>
                                    <td>{{orderHis.orderCreated | formatDate}}</td>
                                </tr>
                                <tr v-if="customerOrderHistory.length === 0">
                                    <td colspan="4">No Previous Order Exist</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row" id="main-content" v-if="Object.keys(order).length > 0 && menu.length > 0 && !this.punchDisabled">
                <div class="col-md-12">
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-2 category_panel">
                                <div class="theiaStickySidebar">
                                    <div class="panel panel-primary ">
                                        <div class="panel-heading">
                                            <b>Menu Categories</b>
                                        </div>
                                        <div class="panel-body" id="menu category_nav_bar">
                                            <ul class="nav">
                                                <li><a href="#most_popular">Most Popular</a></li>
                                                <li v-for="(category, index) in menu" v-if="!category.deleted"  v-bind:key="index+'cat_sidebar'">
                                                    <a v-bind:href="'#' + category.name.replace(/[ /]/g, '')" v-bind:title="category.name" v-bind:class="(category.name.length > 17) ? 'myTip link' : 'link'">{{(category.name.length > 17) ? category.name.substring(0,17)+'...' : category.name}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="panel panel-primary" >
                                    <div class="panel-heading">
                                        <b>Items</b>
                                    </div>
                                    <div class="panel-body">
                                        <multiselect v-model="selectedItem"
                                                     :options="itemOptions"
                                                     :custom-label="customLabel" :track-by="itemOptions.serving"
                                                     @input="findAdOnCategoriesOfItemType(selectedItem)">
                                        </multiselect>
                                        <br/><br/>
                                        <section>
                                            <h3 id="most_popular" class="text-success"><b>Most Popular</b></h3>
                                            <ul class="list-group" >
                                                <template v-for="(mCategory) in menu" >
                                                    <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="menuItem.mostPopular && !menuItem.deleted" v-bind:key="indexMenuItem+'_popular_'+menuItem.name">
                                                        <div class="row">
                                                            <div class="col-md-5">
                                                                <b>{{menuItem.name}}</b>
                                                                <p>{{menuItem.description}}</p>
                                                            </div>
                                                            <div class="col-md-7">
                                                                <table class="menu_table hideTableBottom table table-hover">
                                                                    <tbody>
                                                                    <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-if="!menuItemType.deleted" v-bind:key="indexMenuItemType+'type_popular'">
                                                                        <td>{{menuItemType.serving}}</td>
                                                                        <td v-if="discountOnBranchMenu === true && (!menuItemType.disableDiscount && !menuItem.disableDiscount)" class="text-center">
                                                                          <s>{{menuItemType.price}} Rs.</s>
                                                                          {{calculateDiscountedAmount(order.couponsByCouponId.discount, menuItemType.price, order.couponsByCouponId.inPercentage)}} Rs.</td>
                                                                        <td v-else class="text-center"> {{menuItemType.price}} Rs.</td>
                                                                        <td class="text-right">
                                                                            <button v-on:click="showAdOns(menuItem.menuItemAdOns, menuItemType.id, menuItemType.menuItemTypeAdOns)" class="btn btn-sm btn-primary">Select</button>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>
                                        </section>
                                        <section v-for="(mCategory, index) in menu" v-if="!mCategory.deleted" v-bind:key="index+'cat_main_menu'">
                                            <h3 v-bind:id="mCategory.name.replace(/[ /]/g, '')" class="text-success"><b>{{mCategory.name}}</b></h3>
                                            <ul class="list-group">
                                                <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="!menuItem.deleted" v-bind:key="indexMenuItem+'item_main_menu' + Math.random()">
                                                    <div class="row">
                                                        <div class="col-md-5">
                                                            <b>{{menuItem.name}}</b>
                                                            <p>{{menuItem.description}}</p>
                                                        </div>
                                                        <div class="col-md-7">
                                                            <table class="menu_table hideTableBottom table table-hover">
                                                                <tbody>
                                                                <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-if="!menuItemType.deleted" v-bind:key="indexMenuItemType+'type_main_menu'+Math.random()">
                                                                    <td>{{menuItemType.serving}}</td>
                                                                    <td v-if="discountOnBranchMenu === true && (!menuItemType.disableDiscount && !menuItem.disableDiscount)" class="text-center">
                                                                      <s>{{menuItemType.price}} Rs.</s>
                                                                      {{calculateDiscountedAmount(order.couponsByCouponId.discount, menuItemType.price, order.couponsByCouponId.inPercentage)}} Rs.</td>
                                                                    <td v-else class="text-center"> {{menuItemType.price}} Rs.</td>
                                                                    <td class="text-right">
                                                                        <button v-on:click="showAdOns(menuItem.menuItemAdOns, menuItemType.id, menuItemType.menuItemTypeAdOns)" class="btn btn-sm btn-primary">Select</button>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </section>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-5 cart_panel">
                                <div class="theiaStickySidebar">
                                    <div class="panel panel-primary">
                                        <div class="panel-heading">
                                            <b>Cart</b>
                                            <a title="Discard Order" style="color: #FFF;" v-on:click="discardOrder()" class="myTip pull-right"><b><i class="fa fa-times"></i> Discard</b></a>
                                        </div>
                                        <div class="panel-body">
                                            <div class="table-responsive">
                                                <table class="table table-hover cart_table hideTableBottom table-condensed">
                                                    <thead>
                                                        <tr style="white-space: nowrap;" >
                                                            <th>Quantity</th>
                                                            <th>Item</th>
                                                            <th class="text-center">Serving</th>
                                                            <th class="text-right">Total Price</th>
                                                            <th class="text-right"><i class="fa fa-bolt"></i></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(orderItem, orderItemIndex) in order.orderItemsById" >
                                                            <tr v-bind:key="orderItemIndex">
                                                                <td>
                                                                    <div class="input-group spinner" style="max-width: 60px">
                                                                        <input type="text" readonly="readonly" class="form-control" v-bind:value="orderItem.quantity">
                                                                        <div class="input-group-btn-vertical">
                                                                            <button class="btn btn-primary" v-on:click="updateOrderItemQuantity(orderItemIndex, 'inc')" type="button"><i class="fa fa-caret-up"></i></button>
                                                                            <button class="btn btn-primary" v-on:click="updateOrderItemQuantity(orderItemIndex, 'dec')" type="button"><i class="fa fa-caret-down"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td class="increaseLineHeight" >
                                                                    <a style="white-space: pre-wrap" v-bind:title="(orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name + ', ' +orderItem.menuItemTypesByMenuItemTypeId.serving + '(' + orderItem.menuItemTypesByMenuItemTypeId.price + 'Rs. )')" v-on:click="addInstructions(orderItemIndex, orderItem.instructions)"><b class="text-success">{{orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name}} </b></a>
                                                                    <a v-if="orderItem.orderItemAddOnsById.length > 0" v-on:click="editOrderItemInCart(orderItem, orderItemIndex, false)"> - <i class="fa fa-pencil"></i></a>
                                                                </td>
                                                                <td class="text-center increaseLineHeight">{{orderItem.menuItemTypesByMenuItemTypeId.serving}}</td>
                                                                <td class="text-right increaseLineHeight">{{orderItem.totalPrice | formatNumber}} Rs.</td>
                                                                <td class="text-right increaseLineHeight"><button type="button" v-on:click="removeItemFromCart(orderItemIndex)" class="btn btn-xs btn-danger"><i class="fa fa-times"></i></button></td>
                                                            </tr>
                                                            <template v-for="(itemAddOn, itemAddOnIndex) in orderItem.orderItemAddOnsById">
                                                                <tr v-bind:key="orderItemIndex+'_'+itemAddOnIndex">
                                                                    <td colspan="2">
                                                                        <div class="input-group spinner pull-right" style="max-width: 60px">
                                                                            <input type="text" readonly="readonly" class="form-control" v-bind:value="itemAddOn.quantity">
                                                                            <div class="input-group-btn-vertical">
                                                                                <button class="btn btn-primary" v-on:click="updateAdOnQuantity(orderItemIndex,itemAddOnIndex,'inc')" type="button"><i class="fa fa-caret-up"></i></button>
                                                                                <button class="btn btn-primary" v-on:click="updateAdOnQuantity(orderItemIndex,itemAddOnIndex,'dec')" type="button"><i class="fa fa-caret-down"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td class="text-center increaseLineHeight">{{itemAddOn.addOnItemsByAddOnItemId.name}}</td>
                                                                    <td class="text-right increaseLineHeight" colspan="1">{{(itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price) | formatNumber}} Rs.</td>
                                                                </tr>
                                                            </template>
                                                            <tr v-bind:key="orderItemIndex+'_'" style="border-bottom: solid 1px #CCCCCC">
                                                                <td colspan="5" class="instruction_text">
                                                                    <p class="text-danger" v-bind:title="orderItem.instructions">{{(orderItem.instructions === null) ? '' : orderItem.instructions}}</p>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <tr v-if="order.orderItemsById.length === 0">
                                                            <td colspan="5">No Item In Cart!</td>
                                                        </tr>
                                                        <template v-if="order.orderItemsById.length !== 0">
                                                            <tr>
                                                            <td colspan="3" class="text-right">Subtotal:</td>
                                                            <td class="text-right"><b>{{order.totalPrice | formatNumber}} Rs.</b></td>
                                                        </tr>
                                                            <tr>
                                                                <td colspan="3" class="text-right">Subtotal With AdOn's:</td>
                                                                <td class="text-right"><b>{{order.totalPriceWithAddon | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="3" class="text-right">Discount: <b v-if="order.couponsByCouponId!==null" class="text-info">({{(order.couponsByCouponId.inPercentage) ? order.couponsByCouponId.discount + "%" : order.couponsByCouponId.discount + ".RS" }}) </b></td>
                                                                <td class="text-right"><b>{{order.discount | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="3" class="text-right">Tax Amount <b class="text-info">({{(order.paymentMethod.id===2) ?  order.branchesByBranchId.cardTax : order.branchesByBranchId.tax}})%</b></td>
                                                                <td v-if="parseInt(order.paymentMethod.id)===2" class="text-right"><b>{{Math.round((order.totalPriceWithAddon) * (order.branchesByBranchId.cardTax / 100))}} Rs.</b></td>
                                                                <td v-else class="text-right"><b>{{Math.round((order.totalPriceWithAddon) * (order.branchesByBranchId.tax / 100))}} Rs.</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="3" class="text-right">Sub Total After Tax</td>
                                                                <td class="text-right"><b>{{order.totalPriceAfterTax | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                            <tr v-if="!order.branchesByBranchId.freeDelivery">
                                                                <td colspan="2" class="text-right">Delivery Fee</td>
                                                                <td class="text-right">
                                                                    <input v-bind:disabled="disabledCustomDeliveryFee" class="customDelivery" title="Value can't be more than 99999" v-on:blur="updateCustemDeliveryFeeTextBox(1)" v-model="customDeliveryCharges" type="number" onKeyPress="return !(this.value.length===5)" max="99999" size="15" placeholder="Custom Charges..." />
                                                                    <button v-if="customDeliveryCharges !== ''" v-on:click="updateCustemDeliveryFeeTextBox(0)" class="btn btn-sm btn-link"><i class="fa fa-times"></i></button>
                                                                </td>
                                                                <td class="text-right"><b>{{this.customDeliveryCharges ? Math.round(parseInt(this.customDeliveryCharges)) : order.deliveryFee | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                            <tr v-if="order.branchesByBranchId.freeDelivery">
                                                                <td colspan="3" class="text-right">Delivery Fee</td>
                                                                <!--<td class="text-right"><input v-model="customDeliveryCharges" type="text" size="15" placeholder="Custom Charges..." /></td>-->
                                                                <td class="text-right"><a class="myTip" title="Free Delivery!"><b class="text-info">{{order.deliveryFee | formatNumber}} Rs.</b></a></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" class="text-right">Payment Method</td>
                                                                <td class="text-right">
                                                                    <select style="width:150px" v-model="order.paymentMethod.id" v-on:change="togglePaymentMethod()">
                                                                        <option  v-for="paymentMethod in allPaymentMethods" :key="paymentMethod.id" :value="paymentMethod.id">{{paymentMethod.name}}</option>
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="parseInt(order.paymentMethod.id)===2">
                                                            <td colspan="2" class="text-right">Payment Status</td>
                                                                <td class="text-right">
                                                                    <select style="width:150px;" v-model="order.paymentStatus.id" v-on:change="changePaymentStatus()">
                                                                        <option value="1">Processed</option>
                                                                        <option value="2">Pending</option>
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                              <td colspan="2" class="text-right">Loyalty Points</td>
                                                              <td class="text-right">
                                                                <input class="width-150" title="Add loyalty points" v-model="loyaltyPoints" type="number" min="0" :max="computedBillPrice" size="15" placeholder="Loyalty Points..." />
                                                              </td>
                                                            </tr>
                                                            <tr v-if="!order.branchesByBranchId.freeDelivery">
                                                                <td colspan="3" class="text-right">Billed Price</td>
                                                                <td class="text-right text-success" style="font-size: 15px"><b>{{this.customDeliveryCharges ? Math.round((order.billedPrice - order.deliveryFee - ((order.loyaltyPoints === 0) ? loyaltyPoints : 0)) + parseInt(this.customDeliveryCharges)) : order.billedPrice - ((order.loyaltyPoints === 0) ? loyaltyPoints : 0) | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                            <tr v-if="order.branchesByBranchId.freeDelivery">
                                                            <td colspan="3" class="text-right">Billed Price</td>
                                                            <td class="text-right text-success" style="font-size: 15px"><b>{{(order.billedPrice - order.deliveryFee) - ((order.loyaltyPoints === 0) ? loyaltyPoints : 0) | formatNumber}} Rs.</b></td>
                                                        </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr/>
                                            <div class="row" v-if="order.orderItemsById.length !== 0">
                                                <div class="col-md-4">
                                                    <div class="input-group ">
                                                        <input :disabled="discountOnBranchMenu" :value="discountCode.toUpperCase()" @input="discountCode = $event.target.value.toUpperCase()" type="text" class="form-control" placeholder="Discount Coupon..." />
                                                        <span class="input-group-btn">
                                                            <button :disabled="discountOnBranchMenu" type="button" v-on:click="applyDiscount()" class="btn btn-primary"><i class="fa fa-check" ></i></button>
                                                            <button :disabled="discountOnBranchMenu" title="Remove Discount" type="button" v-on:click="removeDiscount()" class="btn btn-danger myTip"><i class="fa fa-times"></i></button>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <select v-model="orderTypeId" class="form-control" v-on:change="toggleOrderType()">
                                                        <option value="3">Delivery</option>
                                                        <option value="1">Take Away</option>
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <select v-model="newOrderType" class="form-control" @change="updateOrderSource">
                                                            <option v-for="orderSource in orderSources" :key="orderSource.id" :value="orderSource.id">{{orderSource.source}}</option>
                                                    </select>
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" v-on:click="showOrderDetailBeforePunch()" v-bind:disabled="disableOrder" class="pull-right btn btn-primary"><b><i class="fa fa-shopping-cart"></i> GO!</b></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="Object.keys(order).length > 0 && menu.length > 0 && this.punchDisabled">
                <h1 class="text-center text-danger"><b>Restaurant is closed at the moment</b></h1>
                <center><button class="btn btn-danger" @click="discardOrder()">Discard Order</button></center>
            </div>
        </div>
        <AddNewAddress ref="addNewAddressPopup" from="ndo" v-bind:customerId="''" v-bind:customerName="''"/>
        <UpdateCustomer where="deliveryOrder" ref="updateCustomerPopUp" />
        <ViewOrder :showActions="showActions" ref="viewOrderComp"/>
        <!-- Ad - On Modal -->
        <div class="modal fade" id="adOnsPopUp" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="adOnsPopUpLabel">Select Ad'On</h4>
                    </div>
                    <div class="modal-body">
                        <section v-for="adOnCat in selectedMenuItemTypeAdOns" v-if="!adOnCat.deleted" v-bind:key="'itemTypeAdon_cat_modal_' + adOnCat.id + Math.random()">
                            <b>{{adOnCat.addOnCategory.name.split('-->')[0] + ' (' + adOnCat.addOnCategory.allowedItems + ')'}}</b><b class="text-danger small" v-if="adOnCat.addOnCategory.required"> (required)</b>
                            <div class="checkbox" v-for="adOnName in adOnCat.addOnCategory.addOnItemsById" v-bind:key="'itemTypeAdon_cat_item_modal_'+adOnName.id + Math.random()">
                                <label>
                                    <input type="checkbox" v-bind:checked="checkSelectedAdOns(adOnName.id)" v-on:click="checkAdOnLimitAndAddAdOn(adOnCat.addOnCategory.allowedItems, adOnName.id, adOnCat.addOnCategory.id, $event)"/> {{adOnName.name + ' - ' + adOnName.price + ' Rs.'}}
                                </label>
                            </div>
                        </section>
                        <section v-for="adOnCat in selectedAdOnCategory" v-if="!adOnCat.deleted" v-bind:key="'adon_cat_modal_' + adOnCat.id + Math.random()">
                            <b>{{adOnCat.addOnCategory.name.split('-->')[0] + ' (' + adOnCat.addOnCategory.allowedItems + ')'}}</b><b class="text-danger small" v-if="adOnCat.addOnCategory.required"> (required)</b>
                            <div class="checkbox" v-for="adOnName in adOnCat.addOnCategory.addOnItemsById" v-bind:key="'adon_cat_item_modal_'+adOnName.id + Math.random()">
                                <label>
                                    <input type="checkbox" v-bind:checked="checkSelectedAdOns(adOnName.id)" v-on:click="checkAdOnLimitAndAddAdOn(adOnCat.addOnCategory.allowedItems, adOnName.id, adOnCat.addOnCategory.id, $event)"/> {{adOnName.name + ' - ' + adOnName.price + ' Rs.'}}
                                </label>
                            </div>
                        </section>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button v-if="!editOrderItem" type="button" v-on:click="addOrderItem()" class="btn btn-primary">Add To Cart</button>
                        <button v-if="editOrderItem" type="button" v-on:click="editOrderItemInCart(null, null, true)" class="btn btn-primary">Update Cart</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Select Order Journey Modal -->
        <div class="modal fade" id="orderJourney" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 v-if="selectedRestaurant===''" class="modal-title" id="orderJourneyModalLabel">Choose Restaurant</h4>
                        <h4 v-else class="modal-title" id="orderJourneyModalLabel">{{selectedRestaurant.name}}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group" v-if="(userRole === 'ROLE_ADMIN' || userRole === 'ROLE_AGENT' || userRole === 'ROLE_MANAGER') && parseInt(newOrderType) !== 1 && existingCustomer===false">
                            <label>Choose Restaurant</label>
                            <multiselect
                            v-model="selectedRestaurant"
                            :options="allRestaurants"
                            @input="restaurantSelect()"
                            track-by="name"
                            label="name"></multiselect>
                        </div>
                        <div class="col-md-12">
                            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + popUpSpinner">
                                <div class="sk-bounce1"></div>
                                <div class="sk-bounce2"></div>
                                <div class="sk-bounce3"></div>
                            </div>
                        </div>
                        <NewDeliveryOrderCustomer v-show="newCustomer" :order-source="newOrderType" ref="newDeliveryOrderCustomerPopUp"/>

                <div v-show="newCustomer===false">
                    <div>
                        <div class="form group row" style="padding-bottom:10px;">
                                <div class="col-md-6 delivery-custom-btn-div" style="padding-right:5px;">
                                    <button type="button" class="btn btn-w-m delivery-custom-btn" id="choose3" @click="checkDeliveryTakeAway(3)">Delivery</button>
                                </div>
                                <div class="col-md-6 delivery-custom-btn-div" style="padding-left:5px;">
                                    <button type="button" class="btn btn-w-m  delivery-custom-btn" id="choose1" @click="checkDeliveryTakeAway(1)">Take Away</button>
                                </div>
                        </div>
                        <div class="form-group" v-if="orderTypeId === 3">
                            <label>Choose Address | <a class="myTip_address_section" title="Add New Address" v-on:click="openCustomerAddressModal(-1)"><b class="fa fa-plus"></b></a></label>
                            <ul class="list-group" >
                                <li class="list-group-item" v-for="(address, index) in customerAddresses" v-if="!address.deleted && address.areasByAreaId.id!==$store.state.takeAwayAddressId" v-bind:key="'address_' + index">
                                    <div class="i-checks" >
                                        <label :title="( (address.address + ', ' + address.areasByAreaId.name + ', ' + address.areasByAreaId.citiesByCityId.city).length > 40 ) ? (address.address + ', ' + address.areasByAreaId.name + ', ' + address.areasByAreaId.citiesByCityId.city) : ''" style="cursor: pointer" v-on:click="updateNewAddressOfCustomer(address.id, address.areasByAreaId.citiesByCityId.id)">
                                            <input  type="radio"  v-bind:value="address.id" name="address">
                                            {{ (address.address + ', ' + address.areasByAreaId.name + ', ' + address.areasByAreaId.citiesByCityId.city) }}
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="form-group" v-if="(orderTypeId === 1) && Object.keys(tempOrder).length > 0">
                            <label>Select Branch</label>
                            <select class="form-control" v-model="tempOrder.branchesByBranchId.id" v-on:change="changeBranchOfNewOrder(false,orderTypeId)" style="background: #FFFFFF">
                                <option v-for="branch in allBranches" v-bind:key="branch.id+'_branch'" v-bind:value="branch.id">{{branch.areasByAreaId.name}}</option>
                            </select>

                        </div>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>



<!-- Choosee customer modal -->
        <div class="modal fade" id="chooseCustomerModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="chooseCustomerModalLabel">Choose Customer</h4>
                    </div>
                    <div class="modal-body">
                        <h3>{{allCustomers.length}} Records Found For This Number. Kindly Select One</h3>
                        <hr>
                        <li class="list-group-item" v-for="(customer, index) in allCustomers" v-bind:key="'customer_' + index">
                            <div class="i-checks" >
                                <label :title="(customer.name + ', ' + customer.contact1 + ', ' + customer.contact2)" style="cursor:pointer" v-on:click="selectCustomer(customer.id)">
                                    <input  type="radio"  v-bind:value="customer.id" name="customer">
                                    {{ (customer.name + ', ' + customer.contact1 + ', ' + customer.contact2) }}
                                </label>
                            </div>
                        </li>
                    </div>
                </div>
            </div>
        </div>
        <div id="complaint_alert" v-bind:class="alertSection">
            <div class="alert alert-danger">
                <button v-on:click="alertSection = 'hide'" class="close" type="button">×</button>
                Customer Previous Complaint: <br/><b>{{firstComplaint}}</b>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from "../components/layout_components/PageTitle";
    import NewDeliveryOrderCustomer from "../components/orders/NewDeliveryOrderCustomer";
    import UpdateCustomer from "../components/customers/UpdateCustomer";
    import ViewOrder from "../components/orders/ViewOrder";
    import BranchTimings from "../components/restaurants/BranchTimings";
    import AddNewAddress from "../components/customers/AddNewAddress";
    import Multiselect from 'vue-multiselect'
    import DiscountOnMenu from "../components/orders/mixins/DiscountOnMenu";
    import {getOrderDetailsByCallerNumber, saveFoodPandaOrderDetails} from "../api/orders";
    import {getOrderLatestComplaint} from "../api/complaints";
    export default {
        name: "NewDeliveryOrder",
        mixins: [DiscountOnMenu],
        components: {
            AddNewAddress,
            BranchTimings,
            ViewOrder, UpdateCustomer, NewDeliveryOrderCustomer, PageTitle,Multiselect},
        data() {
            return {
                userNameOfExistingOrder: "",
                startBtnDisable: false,
                uan: "",
                selectedRestaurant:'',
                alertSection: "hide",
                firstComplaint: "",
                disabledCustomDeliveryFee:false,
                userRole: "",
                punchDisabled: true,
                customerBlocked: false,
                deliveryEnabled:true,
                pickupEnabled:true,
                callerNumber: "",
                allBranches: [],
                allRestaurants: [],
                order: {},
                tempOrder: {},
                customerOrderHistory: [],
                menu: [],
                customerAddresses:[],
                selectedCustomerAddressId:0,
                allAddressesDisabled: true,
                menuItemSearchQuery: "",
                isHideSpinner: "hide",
                popUpSpinner: "hide",
                discountCode: "",
                orderTypeId: 3,
                isValidContactNumber:false,
                customDeliveryCharges: "",
                selectedOrderItemIndexForEdit: -1,
                editOrderItem:false,
                selectedMenuItemTypeAdOns: [], //we will also show this in popup
                selectedAdOnCategory: [], //we will show this in popup
                selectedMenuItemTypeId: -1, //will be add in cart in final selection
                adOnSelection: {}, //we will add this in final selection in cart
                requiredAdOns:[],
                orderTypes: [],
                newOrderType: 2,
                selectedItem:'',
                itemOptions:[],
                showActions: 'true',
                selectedCityId:'',
                getBranches:'',
                existingCustomer:false,
                branchReOpen:"",
                allCustomers:[],
                newCustomer:"",
                orderSources:[],
                allPaymentMethods:[],
                discountOnBranchMenu: false,
                loyaltyPoints : 0
            }
        },
        computed: {
          disableOrder() {
            return ((this.punchDisabled || !this.deliveryEnabled || this.customerBlocked || this.allAddressesDisabled) && parseInt(this.orderTypeId)===3) || (!this.pickupEnabled && parseInt(this.orderTypeId)===1);
          },
          computedBillPrice() {
            return this.customDeliveryCharges ? Math.round((this.order.billedPrice - this.order.deliveryFee) + parseInt(this.customDeliveryCharges)) : this.order.billedPrice;
          },
          restaurantAndBranchDetailMessageOnPunchOrder() {
            return this.order.orderSource && this.order.orderSource.id === 7 ? 'This order is being sent to ' + this.order.branchesByBranchId.areasByAreaId.name + ' ' + this.order.branchesByBranchId.areasByAreaId.citiesByCityId.city : '';
          }
        },
        watch: {
            selectedRestaurant: function() {
                this.selectedRestaurant && (this.uan = this.selectedRestaurant.uan);
            },
            selectedMenuItemTypeAdOns: function() {
                for(let key in this.selectedMenuItemTypeAdOns){
                    if ( this.selectedMenuItemTypeAdOns.hasOwnProperty(key) ) {
                      (this.selectedMenuItemTypeAdOns[key].addOnCategory.required && !this.selectedMenuItemTypeAdOns[key].deleted) && (this.requiredAdOns.push(this.selectedMenuItemTypeAdOns[key].addOnCategory.id.toString()));
                    }
                }
            },
            selectedAdOnCategory: function() {
                for(let key in this.selectedAdOnCategory){
                    if ( this.selectedAdOnCategory.hasOwnProperty(key) ) {
                        (this.selectedAdOnCategory[key].addOnCategory.required && !this.selectedAdOnCategory[key].deleted ) && (this.requiredAdOns.push(this.selectedAdOnCategory[key].addOnCategory.id.toString()));
                    }
                }
            },
            customDeliveryCharges: function () {
                $(".customDelivery").tooltip("hide");
            },
            newOrderType: function (){
              if (this.order.orderSource) {
                this.updateOrderSource()
                this.order.orderSource.id = this.newOrderType; //foodpanda
                this.order.orderTypesByOrderTypeId.id = this.orderTypeId;
                this.toggleOrderType();
              }

            },
          loyaltyPoints: {
              handler (val) {
                if (val === '') {
                  this.loyaltyPoints = 0
                }
              }
          }
        },
        created: function () {
            let loggedInUser = this.$store.state.user;
            if(loggedInUser){
                this.userRole = loggedInUser.userRolesById[0].role;
            }
            if(this.userRole !== 'ROLE_USER'){
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                    this.allRestaurants = resp.data;
                    console.log(this.allRestaurants);
                    this.$http.get(this.$store.state.mainAppURL + "orders/get_all_order_source").then(resp=>{
                        this.orderSources=resp.data.filter(resp => resp.id !== 1 && resp.id !== 5 && resp.id !== 6 && resp.id !== 9)
                    });
                });
            }
            else if(this.userRole  === 'ROLE_USER'){
                  this.selectedRestaurant = this.$store.state.user.restaurant;
                  this.newOrderType=2;
              }
            this.$http.get(this.$store.state.mainAppURL + "orders/get_all_order_types").then(resp => {
                this.orderTypes = resp.data;
            });
        },
        updated: function () {
            $(".myTip").tooltip();
            $(".cartTip").tooltip({
                placement: "bottom"
            });
            $(".myTip_address_section").tooltip({
                placement:"left"
            });
            $('.cart_panel, .category_panel').theiaStickySidebar({
                additionalMarginTop: 20,
                containerSelector: "#main-content"
            });
            $(".customDelivery").tooltip({
                animate: true,
                trigger: 'manual',
                delay: {
                    "show": 500,
                    "hide": 100
                }
            });
            let $body   = $(document.body);
            let navHeight = $('.category_panel').outerHeight(true) + 10;
            $body.scrollspy({
                target: '.category_panel',
                offset: navHeight
            });
            let self = this;
            $('#customer_address_section').slimScroll({
                height: '145px'
            });
            $('.i-checks').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green',
            });
            $('#orderJourney').on('hidden.bs.modal', ()=>{
                this.selectedRestaurant='';
                this.newCustomer='';
                this.orderType=3;
                this.isHideSpinner= "hide";
            })
            $(".delivery-custom-btn").removeClass("yellow-bg");
            $("#choose"+this.orderTypeId).addClass("yellow-bg");

        },
        mounted: function () {
            if(this.$route.query.customer_number !== undefined){
                this.callerNumber = this.$route.query.customer_number;
                this.isValidContactNumber = true;
                this.makeNewOrderRequest();
            }
            $('#adOnsPopUp').on('hidden.bs.modal', (e) => {
                //reset things related to ad-ons when popup close
                this.adOnSelection = {};
                this.selectedMenuItemTypeId = -1;
                this.selectedAdOnCategory = [];
                this.selectedOrderItemIndexForEdit = -1;
                this.editOrderItem = false;
            });
            // Inputmask({
            //     "mask": "9999-9999999"
            // }).mask($(".callerNumberBox"));
        },
        methods:{
            orderDoesNotExists: function (){
              this.callerNumber = "";
              this.newOrderType = 2;
              this.selectedRestaurant = '';
              this.allBranches = [];
              $("#orderJourney").modal("hide");
            },

            updateOrderFoodpandaDetails: async function () {
                let params = new URLSearchParams();
                params.append("caller_number", this.callerNumber)
                params.append("customer_name", this.order.foodPandaDetails.customerName)
                params.append("foodpanda_order_id", this.order.foodPandaDetails.foodPandaOrderId)
                let saveFoodpandaDetailsResp = await saveFoodPandaOrderDetails(params)
                    .catch(ex => {
                        this.showErrorMessage(ex)
                    });
            },
            TakeOver: async function(){
              let isTakeOver= await Swal.fire({
                title: 'Are you sure?',
                text: "This record is being used by " + this.userNameOfExistingOrder + ". Do you want to take over this record?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Takeover'
              });
              return !!isTakeOver.value;
            },
            UpdateUserOfExistingOrder: async function(){
              let caller_number = new URLSearchParams();
              caller_number.append("caller_number", this.callerNumber);
              let isUpdatedUser= await this.$http.get(this.$store.state.mainAppURL + "orders/update_user_of_existing_order", {
                params: caller_number
              });
              return isUpdatedUser.data;
            },
            clearPageAndDisplayNoOrderExistMsg: function (){
              Swal.fire({
                text: 'No Order Placement Exists!',
                title: "Discard Order",
                type: 'error',
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'Discard'
              }).then(async result => {
                if (result.value) {
                  this.order = {};
                  this.tempOrder = {};
                  this.menu = [];
                  this.callerNumber = "";
                  this.firstComplaint = "";
                  this.selectedRestaurant='';
                  this.newOrderType = 2;
                  this.alertSection = "hide";
                  this.isHideSpinner = "hide";
                  this.popUpSpinner = "hide";
                }
              });

            },
            calculateDiscountedAmount(discountedprice, originalPrice, inPercentage){
              if(inPercentage){
                return Math.floor(originalPrice-(originalPrice*(discountedprice/100)));
              }else{
                return originalPrice-discountedprice;
              }
            },
            customLabel: function (opt){
                return opt.categoryName+" – "+opt.menuItemName+" - "+opt.serving;
            },
            updateCustemDeliveryFeeTextBox: function (mode){
              switch (mode){
                  case 0:
                      this.disabledCustomDeliveryFee = false;
                      this.customDeliveryCharges = "";
                      break;
                  case 1:
                      this.disabledCustomDeliveryFee = true;
                      if(this.customDeliveryCharges === ""){
                          this.disabledCustomDeliveryFee = false;
                          this.customDeliveryCharges = "";
                      }
              }
            },
            checkSelectedAdOns: function (selectedAdOnId) {
                for (let a in this.adOnSelection){
                    for (let aid of this.adOnSelection[a]){
                        if (aid === selectedAdOnId){
                            return true;
                        }
                    }
                }
                return false;
            },
            validateContactNumber: function (e) {
                let contactNumber = $(e.target).val();
                contactNumber = contactNumber.replace("-","");
                this.isValidContactNumber = !isNaN(contactNumber) && (contactNumber.length === 10 || contactNumber.length === 11);
                if(this.isValidContactNumber){
                    this.callerNumber = contactNumber;
                }
            },
            load: async function (updatedOrder){
                $("#orderJourney").modal("hide");
                this.updateOrderSource(updatedOrder);
                this.isHideSpinner = "";
                this.order = updatedOrder;
                this.orderTypeId= this.order.orderTypesByOrderTypeId.id;
                this.punchDisabled = !(this.order.branchesByBranchId.open24Hours || this.order.branchesByBranchId.open);
                if(this.order.customerAddressesByCustomerAddressId!==null){
                    this.customerBlocked = this.order.customerAddressesByCustomerAddressId.customersByCustomerId.customerStatus === 'blocked';
                }
                this.deliveryEnabled = this.order.branchesByBranchId.deliveryEnabled;
                this.pickupEnabled = this.order.branchesByBranchId.pickupEnabled;
                (!this.deliveryEnabled && parseInt(this.orderTypeId)===3) && (swal("Sorry!", "Delivery Not Available for this Branch!", "warning"));
                (!this.pickupEnabled && parseInt(this.orderTypeId)===1) && (swal("Sorry!", "Pickup Not Available for this Branch!", "warning"));

                let branchDeliveryRadius = this.order.branchesByBranchId.deliveryRadius;
                let customerAreaToBranchAreaDistance = this.order.totalDistance / 2;
                (!this.punchDisabled && parseInt(this.orderTypeId)===3 && (branchDeliveryRadius < customerAreaToBranchAreaDistance)) && (this.distanceOfCustomerIsBeyondBranchRadius(branchDeliveryRadius));
                if(this.order.couponsByCouponId !== null){
                    this.discountCode = this.order.couponsByCouponId.couponCode;
                }
                let params = new URLSearchParams();
                params.append("restaurant_id", this.order.branchesByBranchId.restaurantsByRestaurantId.id);
                if(this.order.orderTypesByOrderTypeId.id===1){

                    console.log("Take away order");
                    this.getBranches= 'get_all_branches';
                }
                else{

                    params.append("city_id", this.order.customerAddressesByCustomerAddressId.areasByAreaId.citiesByCityId.id);
                    this.getBranches= 'get_all_branches_of_selected_city'
                }
                this.$http.post(this.$store.state.mainAppURL + "restaurants/" + this.getBranches, params).then(resp => {
                    this.allBranches = resp.data;
                });
                if(this.order.couponsByCouponId !== null && this.order.branchesByBranchId.couponsById !== null && this.order.branchesByBranchId.applyOnDvm){
                  this.discountCode= this.order.branchesByBranchId.couponById.couponCode;
                  this.discountOnBranchMenu = true;
                }
                else {
                  this.discountCode = "";
                  this.discountOnBranchMenu = false;
                }
                this.fetchCustomerAddresses();
                this.fetchOrderHistoryByCustomerId()
                this.fetchBranchMenu();
                this.getAllPaymentMethods();
                console.log(this.order);
            },
            distanceOfCustomerIsBeyondBranchRadius: function (branchDeliveryRadius) {
              Swal.fire({
                title: 'WARNING!',
                text: "Branch only deliver orders within "+ branchDeliveryRadius +"km of radius!\n Do you still want to place your order?",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'No',
                confirmButtonColor: '#1ab394',
                confirmButtonText: 'Yes'
              }).then(async (resp) => {
                if (!resp.value) {
                  this.discardOrder()
                }
              })
            },
            isBranchOpen: function (timings) {
                let timingObj = JSON.parse(timings);
                let days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
                let toDay = days[new Date().getDay()];
                let toDate = new Date();
                for (let t = 0; t < timingObj.length; t++){
                    if(timingObj[t].day.toLowerCase() === toDay.toLowerCase()){
                        this.branchReOpen= timingObj[t+1];
                        if(this.branchReOpen===undefined){
                            this.branchReOpen=timingObj[0]
                        }
                        (typeof timingObj[t].starting === "number") && ( timingObj[t].starting = ('0'+timingObj[t].starting).slice(-2)+':00' );
                        (typeof timingObj[t].closing === "number") && ( timingObj[t].closing = ('0'+timingObj[t].closing).slice(-2)+':00' );

                        let openTime = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), parseInt(timingObj[t].starting.split(":")[0]), parseInt(timingObj[t].starting.split(":")[1]));
                        let closingTime = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), parseInt(timingObj[t].closing.split(":")[0]), parseInt(timingObj[t].closing.split(":")[1]));

                        (typeof timingObj[t].closesOnNextDay === "string") && (timingObj[t].closesOnNextDay === 'false' ? timingObj[t].closesOnNextDay = false : timingObj[t].closesOnNextDay = true);

                        if(timingObj[t].closesOnNextDay){
                            closingTime.setDate(closingTime.getDate()+1);
                        }

                        if(closingTime.getHours()===0 ) {
                            if(toDate > openTime && closingTime.getHours() < 24) {
                                return true;
                            }
                            return false;
                        }
                        console.log("ToDay: " , toDate.toString());
                        console.log("Open: " + openTime.toString());
                        console.log("Close:" + closingTime.toString());
                        return (toDate > openTime && toDate < closingTime);
                    }
                }
            },
            initializeOrderFirst: async function (initialOrderData) {
                $("#orderJourney").modal("hide");
                this.tempOrder = initialOrderData;
                await this.fetchCustomerAddresses();
                let params = new URLSearchParams();
                params.append("restaurant_id", this.tempOrder.branchesByBranchId.restaurantsByRestaurantId.id);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                    this.allBranches = resp.data;
                    // this.tempOrder.branchesByBranchId.id = -1;
                });
                $(".delivery-custom-btn").removeClass("yellow-bg");
                this.orderTypeId=3;
                this.load(this.tempOrder);
                this.isHideSpinner = "hide";
            },
            restaurantSelect: async function(){
                let params1 = new URLSearchParams();
                params1.append("caller_number", this.callerNumber);
                let isDiscardCustomer = await this.$http.post(this.$store.state.mainAppURL + "orders/discard_order_placement", params1);
                await this.createOrder();
            },
            createOrder: async function(){
                let params = new URLSearchParams();
                params.append("contact_number",this.callerNumber);
                params.append("uan", this.uan);
                params.append("order_source", this.newOrderType);
                this.isHideSpinner = "";
                this.$http.post(this.$store.state.mainAppURL + "orders/check_delivery_order_request", params).then(async (resp) => {
                    if(resp.data==="" || resp.data===null){
                        let parmas1 = new URLSearchParams()
                        parmas1.append("caller_number", this.callerNumber);
                        let resp1= await this.$http.post(this.$store.state.mainAppURL + "orders/fetch_all_customers_of_number", parmas1);
                            console.log("Responce");
                            console.log(resp1.data);
                            this.allCustomers= resp1.data;
                            $("#chooseCustomerModal").modal("show");
                            return;
                    }
                    this.selectedRestaurant= resp.data.branchesByBranchId.restaurantsByRestaurantId;
                    if(resp.data.orderSource) {
                        this.newOrderType = resp.data.orderSource.id;
                    }
                    if(resp.data.customerAddressesByCustomerAddressId === null){
                        this.order = {};
                        this.newCustomer=true;
                        $("#orderJourney").modal("show");
                        this.$refs.newDeliveryOrderCustomerPopUp.load(resp.data.branchesByBranchId.restaurantsByRestaurantId, this.callerNumber);
                        this.isHideSpinner = "hide";
                    }else if( resp.data.totalDistance===null && resp.data.orderTypesByOrderTypeId.id!==1) {
                      console.log('pos')
                            this.newCustomer=false;
                            this.tempOrder= resp.data;
                            let params = new URLSearchParams();
                            this.tempOrder.branchesByBranchId.id="";
                            params.append("restaurant_id", this.tempOrder.branchesByBranchId.restaurantsByRestaurantId.id);
                            this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(async resp => {
                                this.allBranches = resp.data;
                                await this.fetchCustomerAddresses();
                                $("#orderJourney").modal("show");
                            });

                        }else{
                            this.load(resp.data);
                        }
                })
            },
            makeNewOrderRequest: function () {
                if(!this.isValidContactNumber){
                    this.isValidContactNumber = false;
                    return swal("Error!", "Invalid Contact Number!", "error");
                }
                this.order = {};
                let params = new URLSearchParams();
                params.append("contact_number", this.callerNumber);
                this.$http.post(this.$store.state.mainAppURL + "orders/check_delivery_order_in_hashmap", params).then(async (response) => {
                  if (!response.data) {
                    if ((this.userRole === "ROLE_ADMIN" || this.userRole === "ROLE_AGENT" || this.userRole === "ROLE_MANAGER") && parseInt(this.newOrderType) !== 1 && this.existingCustomer === false) {
                      this.newCustomer = '';
                      $("#orderJourney").modal("show");
                      return;
                    }
                    this.existingCustomer = false;
                  }
                  await this.createOrder();
                });
            },
            updateNewAddressOfCustomer: function (addressId, cityId) {
                this.popUpSpinner="";
                this.startBtnDisable = true;
                this.customerAddresses = [];
                this.selectedCustomerAddressId = addressId;
                this.selectedCityId= cityId;
                let params = new URLSearchParams();
                params.append("caller_number", this.callerNumber);
                params.append("address_id", addressId);
                this.isHideSpinner = "";
                this.$http.post(this.$store.state.mainAppURL + "orders/update_customer_address_in_delivery_order", params).then(resp => {
                    if(resp.data === '' || resp.data === null){
                      this.clearPageAndDisplayNoOrderExistMsg();
                    }else {
                      this.load(resp.data);
                      this.popUpSpinner = "hide";
                    }
                    $("#orderJourney").modal("hide");
                }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            changeBranchOfNewOrder: function (isFindOptimize, orderTypeId){
                $("#orderJourney").modal("hide");
                this.orderTypeId= orderTypeId;
                let params = new URLSearchParams();
                if(this.order.branchesByBranchId === undefined){
                    params.append("branch_id", this.tempOrder.branchesByBranchId.id);
                }else{
                    params.append("branch_id", this.order.branchesByBranchId.id);
                }
                params.append("is_find_optimize", isFindOptimize);
                params.append("order_type", orderTypeId);
                params.append("order_source", this.newOrderType);
                params.append("caller_number", this.callerNumber);
                this.isHideSpinner = "";
                this.$http.post(this.$store.state.mainAppURL + "orders/update_branch_in_delivery_order", params).then(resp => {
                    if(!resp.data){
                      this.clearPageAndDisplayNoOrderExistMsg();
                    }else {
                      this.load(resp.data);
                      this.isHideSpinner = "hide";
                    }
                }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            fetchOrderHistoryByCustomerId: function(){
                let customer_id= this.order.customerAddressesByCustomerAddressId.customersByCustomerId.id;
                let res_id= this.order.branchesByBranchId.restaurantsByRestaurantId.id;
                this.$http.get(this.$store.state.mainAppURL + "orders/get_all_orders_of_customer_of_specific_restaurant", {params: {customer_id: customer_id, restaurant_id: res_id}}).then(async resp => {
                  this.customerOrderHistory = resp.data;
                  this.firstComplaint = "";
                  this.alertSection = "hide";
                  for (let i = 0; i < this.customerOrderHistory.length; i++) {
                    if (this.customerOrderHistory[i].complainCount > 0) {
                      let firstComplaint = await getOrderLatestComplaint(this.customerOrderHistory[i].orderId);
                      this.firstComplaint = firstComplaint.data;
                      this.alertSection = "";
                      break;
                    }
                  }
                }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            discardOrderWithValidUser: function() {
              Swal({
                title: 'Are you sure?',
                text: "Are you sure you want to discard this order! This will delete all order data from cache.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, discard it!'
              }).then((result) => {
                if (result.value) {
                  this.isHideSpinner = "";
                  let params2 = new URLSearchParams();
                  params2.append("caller_number", this.callerNumber);
                  this.$http.post(this.$store.state.mainAppURL + "orders/discard_order_placement", params2).then(resp => {
                    if (resp.data) {
                      this.order = {};
                      this.tempOrder = {};
                      this.menu = [];
                      this.callerNumber = "";
                      // this.uan = "";
                      this.firstComplaint = "";
                      this.alertSection = "hide";
                      this.selectedRestaurant='';
                      swal("SUCCESS!", "Order has been successfully discarded", "success");
                    } else {
                      swal("Error!", "Invalid Placement", "error");
                    }
                    this.isHideSpinner = "hide";
                  }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                  });
                }
              });
            },
            discardOrder: function () {
              let callerNumber= new URLSearchParams();
              callerNumber.append("callerNumber", this.callerNumber);
              this.$http.get(this.$store.state.mainAppURL+ "orders/verify_user_of_existing_order", {
                params: callerNumber
              }).then(async resp => {
                if(resp.data === "" || resp.data === null){
                  this.clearPageAndDisplayNoOrderExistMsg();
                }
                else if (resp.data === true) {
                  this.discardOrderWithValidUser();
                } else {
                  this.userNameOfExistingOrder = this.order.usersByUserId.fullName;
                  let isTakeover = await this.TakeOver();
                  if (isTakeover) {
                    let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                    if (isUpdateUserOfExistingOrder) {
                      this.discardOrderWithValidUser();
                    }
                  }
                }
              });
            },
            //open modal functions
            openCustomerAddressModal: function (addressId) {
                this.popUpSpinner="";
                if(this.order.customerAddressesByCustomerAddressId!==undefined){
                    this.$refs.addNewAddressPopup.setProps(this.order.customerAddressesByCustomerAddressId.customersByCustomerId.id,
                    this.order.customerAddressesByCustomerAddressId.customersByCustomerId.name);
                }
                else{
                    this.$refs.addNewAddressPopup.setProps(this.tempOrder.customerAddressesByCustomerAddressId.customersByCustomerId.id,
                    this.tempOrder.customerAddressesByCustomerAddressId.customersByCustomerId.name);
                }
                if(addressId === -1) {
                    this.$refs.addNewAddressPopup.loadForNewInsertion(addressId);
                }else{
                    this.$refs.addNewAddressPopup.loadForUpdate(addressId);
                }
            },
            fetchCustomerAddresses: async function () {
                let params2 = new URLSearchParams();
                this.customerAddresses = [];
                if(this.order.customerAddressesByCustomerAddressId === undefined){
                    params2.append("customer_id", this.tempOrder.customerAddressesByCustomerAddressId.customersByCustomerId.id);
                }else{
                    params2.append("customer_id", this.order.customerAddressesByCustomerAddressId.customersByCustomerId.id);
                }
                try {
                    const resp= await this.$http.post(this.$store.state.mainAppURL + "customers/get_all_customer_addresses", params2)
                        this.customerAddresses = resp.data;

                    for(let i=0;i<this.customerAddresses.length;i++) {
                        if (this.selectedCustomerAddressId!==0){
                            let temp = [];
                            if (this.customerAddresses[i].id===this.selectedCustomerAddressId){
                                temp = this.customerAddresses[0];
                                this.customerAddresses[0] = this.customerAddresses[i];
                                this.customerAddresses[i] = temp;
                            }
                        }
                    }

                    for(let address of this.customerAddresses){
                        this.allAddressesDisabled = true;
                        if(!address.deleted){
                            this.allAddressesDisabled = false;
                            break;
                        }
                    }
                }catch(e){

                }
            },
            openCustomerInformationModal: function () {
                this.$refs.updateCustomerPopUp.load(
                    this.order.customerAddressesByCustomerAddressId.customersByCustomerId.id);
            },
            updateCustomerInfoInOrderObject: function () {
                let params2 = new URLSearchParams();
                params2.append("customer_id", this.order.customerAddressesByCustomerAddressId.customersByCustomerId.id);
                this.$http.post(this.$store.state.mainAppURL + "customers/get_customer_detail", params2).then(resp => {
                    let updatedCustomer = resp.data;
                    delete updatedCustomer["blockReasons"];
                    delete updatedCustomer["created"];
                    delete updatedCustomer["modified"];
                    this.order.customerAddressesByCustomerAddressId.customersByCustomerId = updatedCustomer;
                });
            },
            openOrderDetailModal: function (orderId){
                this.showActions = 'true';
                this.$refs.viewOrderComp.fetchOrderDetail(orderId);
            },
            //////////////////////
            findAdOnCategoriesOfItemType: function (menuItem) {
                if (menuItem) {
                    let menuItemTypeId = menuItem.id;
                    for (let i = 0; i < this.menu.length; i++) {
                        for (let j = 0; j < this.menu[i].menuItemsById.length; j++) {
                            for (let k = 0; k < this.menu[i].menuItemsById[j].menuItemTypesById.length; k++) {
                                if (this.menu[i].menuItemsById[j].menuItemTypesById[k].id === menuItemTypeId) {
                                    this.showAdOns(this.menu[i].menuItemsById[j].menuItemAdOns, menuItemTypeId, this.menu[i].menuItemsById[j].menuItemTypesById[k].menuItemTypeAdOns);
                                    this.selectedItem = null;
                                    return;
                                }
                            }
                        }
                    }
                }
            },
            showAdOns: function(menuAdOnsCategories, menuItemTypeId, menuItemTypeAdOns) {
                this.selectedMenuItemTypeId = menuItemTypeId;
                if(menuAdOnsCategories.length === 0 && menuItemTypeAdOns.length === 0){
                    this.requiredAdOns = []
                    this.addOrderItem();
                }else{
                    this.requiredAdOns = []
                    this.selectedAdOnCategory = $.extend(true, {}, menuAdOnsCategories);
                    this.selectedMenuItemTypeAdOns = $.extend(true, {}, menuItemTypeAdOns);
                    console.log(this.selectedMenuItemTypeAdOns);
                    $("#adOnsPopUp").modal("show");
                }
            },
            checkAdOnLimitAndAddAdOn: function(limit, adOnItemId, adOnCategoryId, e) {
                let existingAdOns = this.adOnSelection[adOnCategoryId];
                if(e.target.checked){
                    if(existingAdOns === undefined){
                        this.adOnSelection[adOnCategoryId] = [];
                        this.adOnSelection[adOnCategoryId].push(adOnItemId);
                    }else if(existingAdOns.length === limit){
                        swal("ERROR!", "You can not add more ad ons!", "error");
                        e.target.checked = false;
                    }else{
                        this.adOnSelection[adOnCategoryId].push(adOnItemId);
                    }
                }else{
                    let index = existingAdOns.indexOf(adOnItemId);
                    if (index > -1) {
                        existingAdOns.splice(index, 1);
                    }
                }
                console.log(this.adOnSelection);
            },
            editOrderItemInCart: function (orderItem, orderItemIndex, onlyUpdate) {
                if(!onlyUpdate){
                    console.log(orderItem);
                    for(let orderItemAdon of orderItem.orderItemAddOnsById){
                        if(this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id] === undefined){
                            this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id] = [];
                        }
                        this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id].push(orderItemAdon.addOnItemsByAddOnItemId.id);
                    }
                    console.log(this.adOnSelection);
                    for(let menuCategory of this.menu){
                        for(let menuItem of menuCategory.menuItemsById){
                          for(let menuItemTypes of menuItem.menuItemTypesById) {
                            if (menuItem.id === orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id && menuItemTypes.id === orderItem.menuItemTypesByMenuItemTypeId.id) {
                              this.selectedOrderItemIndexForEdit = orderItemIndex;
                              this.editOrderItem = true;
                              this.showAdOns(menuItem.menuItemAdOns, orderItem.menuItemTypesByMenuItemTypeId.id, menuItemTypes.menuItemTypeAdOns);
                              break;
                            }
                          }
                        }
                    }
                }else{
                    console.log("Updating Cart...");
                    console.log(this.selectedOrderItemIndexForEdit);
                    console.log(this.editOrderItem);
                    let adOns = [];
                    let selectedAdOns = [];
                    for (var key in this.adOnSelection) {
                        if(this.adOnSelection.hasOwnProperty(key) && this.adOnSelection[key].length > 0){
                            selectedAdOns.push(key.toString());
                            adOns.push(this.adOnSelection[key]);
                        }

                    }
                    console.log(adOns.join());
                    if (this.requiredAdOns.every((i) => selectedAdOns.includes(i))){
                    this.isHideSpinner = "";
                    let params = new URLSearchParams();
                    params.append("ad_ons", adOns.join());
                    params.append("caller_number", this.callerNumber);
                    params.append("order_item_index", this.selectedOrderItemIndexForEdit);
                    this.$http.post(this.$store.state.mainAppURL + "orders/update_order_item_in_order_request", params).then(async resp => {
                      if (resp.data.user_name !== undefined) {
                        this.userNameOfExistingOrder = resp.data.user_name;
                        let isTakeOver = await this.TakeOver();
                        if (isTakeOver === true) {
                          let caller_number = new URLSearchParams();
                          caller_number.append("caller_number", this.callerNumber);
                          await this.$http.get(this.$store.state.mainAppURL + "orders/update_user_of_existing_order", {
                            params: caller_number
                          }).then(async response => {
                            if (response.data)
                              await this.editOrderItemInCart(orderItem, orderItemIndex, onlyUpdate);
                          })
                        }
                      }
                      else if(resp.data == ""||resp.data == null) {
                        this.clearPageAndDisplayNoOrderExistMsg();
                        $("#adOnsPopUp").modal("hide");
                      }
                      else {
                        this.order = resp.data;
                        $("#adOnsPopUp").modal("hide");
                      }
                      this.isHideSpinner = "hide";
                    }).catch(ex => {
                        this.isHideSpinner = "hide";
                        swal("Error!", ex + " Please try again", "error");
                    });
                }else { swal("Warning!","Make Sure at least One option of each Required Ad'On(s) is Selected", "warning") }

            }


            },
            addOrderItem: async function () {
              // console.log("Going to add in cart: \n");
              let adOns = [];
              let selectedAdOns = [];
              for (var key in this.adOnSelection) {
                if (this.adOnSelection.hasOwnProperty(key) && this.adOnSelection[key].length > 0) {
                  selectedAdOns.push(key.toString());
                  adOns.push(this.adOnSelection[key]);
                }
              }
              if (this.requiredAdOns.every((i) => selectedAdOns.includes(i))) {
                this.isHideSpinner = "";
                let params = new URLSearchParams();
                params.append("serving_id", this.selectedMenuItemTypeId);
                params.append("ad_ons", adOns.join());
                params.append("caller_number", this.callerNumber);
                await this.$http.post(this.$store.state.mainAppURL + "orders/add_new_order_item_in_order_request", params).then(async resp => {
                  if (resp.data.user_name !== undefined) {
                    this.userNameOfExistingOrder= resp.data.user_name;
                    let isTakeOver= await this.TakeOver();
                    if(isTakeOver === true) {
                      let caller_number = new URLSearchParams();
                      caller_number.append("caller_number", this.callerNumber);
                      await this.$http.get(this.$store.state.mainAppURL + "orders/update_user_of_existing_order", {
                        params: caller_number
                      }).then(async resp => {
                        if (resp.data)
                          await this.addOrderItem();
                      })
                    }
                  }
                  else if(resp.data=== ""|| resp.data=== null){
                    this.clearPageAndDisplayNoOrderExistMsg();
                    $("#adOnsPopUp").modal("hide");
                  }
                  else{
                    this.order = resp.data;
                    $("#adOnsPopUp").modal("hide");
                  }
                  this.isHideSpinner = "hide";
                }).catch(ex => {
                  this.isHideSpinner = "hide";
                  swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
              } else {
                swal("Warning!", "Make Sure at least One option of each Required Ad'On(s) is Selected", "warning")
              }
            },
            updateOrderItemQuantity: async function (orderItemIndex, operation) {
              switch (operation) {
                case 'inc':
                  if (this.order.orderItemsById[orderItemIndex].quantity < 20) {
                    this.order.orderItemsById[orderItemIndex].quantity += 1;
                  }
                  break;
                case 'dec':
                  if (this.order.orderItemsById[orderItemIndex].quantity > 1) {
                    this.order.orderItemsById[orderItemIndex].quantity -= 1;
                  }
                  break;
              }

              let params = new URLSearchParams();
              params.append("order_item_index", orderItemIndex);
              params.append("quantity", this.order.orderItemsById[orderItemIndex].quantity);
              params.append("caller_number", this.callerNumber);
              await this.$http.post(this.$store.state.mainAppURL + "orders/update_quantity_in_order_request", params)
                  .then(async resp => {
                    if (resp.data.user_name !== undefined) {
                      this.userNameOfExistingOrder= resp.data.user_name;
                      let isTakeover = await this.TakeOver();
                      if (isTakeover) {
                        let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                        if (isUpdateUserOfExistingOrder) {
                          await this.updateOrderItemQuantity(orderItemIndex, operation);
                        }
                      }
                    }
                    else if(resp.data=== ""|| resp.data === null){
                      this.clearPageAndDisplayNoOrderExistMsg();
                    }
                    else{
                      this.order= resp.data;
                    }
                  }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                  });
            },
            updateAdOnQuantity: function (orderItemIndex, adOnIndex, operation) {
              switch (operation) {
                case 'inc':
                  if(this.order.orderItemsById[orderItemIndex].orderItemAddOnsById[adOnIndex].quantity < 20){
                    this.order.orderItemsById[orderItemIndex].orderItemAddOnsById[adOnIndex].quantity += 1;
                  }
                  break;
                case 'dec':
                  if(this.order.orderItemsById[orderItemIndex].orderItemAddOnsById[adOnIndex].quantity > 1){
                    this.order.orderItemsById[orderItemIndex].orderItemAddOnsById[adOnIndex].quantity -= 1;
                  }
                  break;
              }
                let params = new URLSearchParams();
                params.append("order_item_index", orderItemIndex);
                params.append("ad_on_item_index",adOnIndex);
                params.append("quantity", this.order.orderItemsById[orderItemIndex].orderItemAddOnsById[adOnIndex].quantity);
                params.append("caller_number", this.callerNumber);
                this.$http.post(this.$store.state.mainAppURL + "orders/update_quantity_in_order_request", params).then(async resp => {
                  if (resp.data.user_name !== undefined) {
                    this.userNameOfExistingOrder= resp.data.user_name;
                    let isTakeover = await this.TakeOver();
                    if (isTakeover) {
                      let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                      if (isUpdateUserOfExistingOrder) {
                        await this.updateAdOnQuantity(orderItemIndex, adOnIndex, operation);
                      }
                    }
                  } else if(resp.data=== ""|| resp.data === null){
                    this.clearPageAndDisplayNoOrderExistMsg();
                  }
                  else {
                    this.order = resp.data;
                  }
                }).catch(ex => {
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            removeItemFromCart: function (orderItemIndex) {
                this.isHideSpinner = "";
                let params = new URLSearchParams();
                params.append("order_item_index", orderItemIndex);
                params.append("caller_number", this.callerNumber);
                this.$http.post(this.$store.state.mainAppURL + "orders/remove_order_item_in_order_request", params).then(async resp => {
                  if (resp.data.user_name !== undefined) {
                    this.userNameOfExistingOrder= resp.data.user_name;
                    let isTakeover = await this.TakeOver();
                    if (isTakeover) {
                      let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                      if (isUpdateUserOfExistingOrder) {
                        let updatedOrderResp = await getOrderDetailsByCallerNumber(this.callerNumber);
                        if(updatedOrderResp.data.status === 200){
                          swal("Success", "Updated Order", "success");
                          this.order = updatedOrderResp.data.body;
                        }else{
                          this.clearPageAndDisplayNoOrderExistMsg();
                        }
                        // this.removeItemFromCart(orderItemIndex);
                      }
                    }
                  }
                  else if(resp.data=== "" || resp.data === null) {
                    this.clearPageAndDisplayNoOrderExistMsg();
                  }
                  else {
                    this.order = resp.data;
                  }
                  this.isHideSpinner = "hide";
                }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            addInstructions: function (orderItemArrayIndex, existingInstructions) {
                if(existingInstructions === null) {
                    existingInstructions = "";
                }
                swal({
                    title: 'Enter Instructions',
                    showCancelButton: true,
                    confirmButtonText: 'Save',
                    html:
                        '<textarea class="form-control" rows="5" placeholder="Instructions..." id="swal_instructions">'+existingInstructions+'</textarea>',
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            resolve($("#swal_instructions").val())
                        })
                    },
                    onOpen: function () {
                        $('#swal_instructions').focus();
                    }
                }).then( (result) => {
                    if(result.dismiss === "overlay" || result.dismiss === "cancel") {
                        return false;
                    }
                    if(result.value === true){
                        result.value = "";
                    }
                    this.isHideSpinner = "";
                    let params = new URLSearchParams();
                    params.append("instructions", result.value);
                    params.append("order_item_index", orderItemArrayIndex);
                    params.append("caller_number", this.callerNumber);
                    this.$http.post(this.$store.state.mainAppURL + "orders/add_instruction_in_order_request", params).then(resp => {
                      if(resp.data === '' || resp.data === null){
                        this.clearPageAndDisplayNoOrderExistMsg();
                      }else {
                        this.order = resp.data;
                        this.isHideSpinner = "hide";
                      }
                    }).catch(ex => {
                        this.isHideSpinner = "hide";
                        swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                    });
                }).catch(swal.noop);
            },
            applyDiscount: async function () {
                let params = new URLSearchParams();
                params.append("code", this.discountCode);
                params.append("caller_number", this.callerNumber);
                await this.$http.post(this.$store.state.mainAppURL + "orders/apply_discount_in_order_request", params).then(async resp => {
                  if (resp.data.user_name !== undefined) {
                    this.userNameOfExistingOrder= resp.data.user_name;
                    let isTakeover = await this.TakeOver();
                    if (isTakeover) {
                      let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                      if (isUpdateUserOfExistingOrder) {
                        this.applyDiscount();
                      }
                    }
                  }
                  else if(resp.data=== ""|| resp.data === null){
                    this.clearPageAndDisplayNoOrderExistMsg();
                  }
                  else {
                    let previousDiscount = this.order.discount;
                    this.order = resp.data;
                    if (previousDiscount === this.order.discount) {
                      swal("ERROR!", "Invalid Coupon or already reedemed! Contact DVM Tech Support", "error");
                      this.discountCode = "";
                      return;
                    }
                    swal("SUCCESS!", "Coupon has been reedemed successfully!", "success");
                    this.order = resp.data;
                  }
                }).catch(ex => {
                  swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            removeDiscount: function () {
              let params = new URLSearchParams();
              params.append("caller_number", this.callerNumber);
              this.$http.post(this.$store.state.mainAppURL + "orders/remove_discount_in_order_request", params).then(async resp => {
                if (resp.data.user_name !== undefined) {
                  this.userNameOfExistingOrder= resp.data.user_name;
                  let isTakeover = await this.TakeOver();
                  if (isTakeover) {
                    let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                    if (isUpdateUserOfExistingOrder) {
                      this.removeDiscount();
                    }
                  }
                } else if(resp.data=== ""|| resp.data === null){
                  this.clearPageAndDisplayNoOrderExistMsg();
                }
                else {
                  swal("SUCCESS!", "Coupon has been successfully removed!", "success");
                  this.order = resp.data;
                  this.discountCode = "";
                  this.loyaltyPoints = 0
                }
              }).catch(ex => {
                swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
              });
            },
            showOrderDetailBeforePunch: function () {
              if (this.loyaltyPoints < 0 || this.loyaltyPoints > this.computedBillPrice) {
                swal("Error", "Loyalty Points are not valid!", "error");
                return;
              }
              if(this.order.orderSource.id === 7 &&
                  (this.order.foodPandaDetails.customerName === null || this.order.foodPandaDetails.foodPandaOrderId === null)
              ){
                  swal("Error", "Enter Foodpanda Details!", "error");
                  return;
              }
              let callerNumber= new URLSearchParams();
              callerNumber.append("callerNumber", this.callerNumber);
              this.$http.get(this.$store.state.mainAppURL+ "orders/verify_user_of_existing_order", {
                params: callerNumber
              }).then(async resp => {
                if(resp.data){
                  if (parseInt(this.orderTypeId) === 3 && this.order.customerAddressesByCustomerAddressId.areasByAreaId.id === this.$store.state.takeAwayAddressId) {
                    swal("Add Address!", " Please Add/Select To proceed", "error");
                    return;
                  }
                  if (this.customDeliveryCharges <= 99999) {
                    this.showActions = 'false';
                    this.$refs.viewOrderComp.fetchOrderToPunchDetail(this.callerNumber, this.customDeliveryCharges, this.loyaltyPoints);
                  } else {
                    $(".customDelivery").tooltip("show");
                  }
                } else {
                  this.userNameOfExistingOrder = this.order.usersByUserId.fullName;
                  let isTakeover = await this.TakeOver();
                  if (isTakeover) {
                    let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                    if (isUpdateUserOfExistingOrder) {
                      let updatedOrderResp = await getOrderDetailsByCallerNumber(this.callerNumber);
                      if(updatedOrderResp.data.status === 200){
                        swal("Success", "Updated Order", "success");
                        this.order = updatedOrderResp.data.body;
                      }else {
                        this.showOrderDetailBeforePunch();
                      }
                    }
                  }
                }
              });
            },
                saveOrder: function () {
                    Swal({
                        title: 'Are You Sure!',
                        html: "Are You Sure You Want To Punch This Order <br><small>" + this.restaurantAndBranchDetailMessageOnPunchOrder + '</small>',
                        input: 'textarea',
                        inputPlaceholder: "Any Order Wide Instructions....",
                        showCancelButton: true,
                        confirmButtonText: 'Punch',
                        showLoaderOnConfirm: true,
                        preConfirm: (instructions) => {
                            let params = new URLSearchParams();
                            params.append("caller_number", this.callerNumber);
                            params.append("custom_delivery_charges", this.customDeliveryCharges);
                            params.append("order_type", this.orderTypeId);
                            params.append("order_wide_ins", instructions);
                            return this.$http.post(this.$store.state.mainAppURL + "orders/save_order_from_order_request", params).then(resp => {
                                if(!resp.data){
                                  this.clearPageAndDisplayNoOrderExistMsg();
                                  return;
                                }else {
                                  console.log(resp.data);
                                  return resp.data;
                                }
                            }).catch(ex => {
                                this.showErrorMessage(ex)
                                return false;
                            });
                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                        console.log(result);
                        if (result.value) {
                            swal("SUCCESS!", "Order has been successfully punched", "success");
                            this.$router.push("/orders");
                        }
                    });
            },
            checkDeliveryTakeAway: function(orderType){
                this.orderTypeId=orderType;
                console.log(this.orderTypeId)
                $(".delivery-custom-btn").removeClass("yellow-bg");
                $('#choose'+this.orderTypeId).addClass("yellow-bg");
            },
            toggleOrderType() {
              console.log("orderTypeId: ",this.orderTypeId);
              this.isHideSpinner = "";
              let params = new URLSearchParams();
              params.append("order_type", this.orderTypeId);
              params.append("caller_number", this.callerNumber);
              this.$http.post(this.$store.state.mainAppURL + "orders/update_ordertype_in_delivery_order", params).then(async resp => {
                if (resp.data.user_name!== undefined) {
                  this.userNameOfExistingOrder= resp.data.user_name;
                  let isTakeover = await this.TakeOver();
                  if (isTakeover) {
                    let isUpdateUserOfExistingOrder = await this.UpdateUserOfExistingOrder();
                    if (isUpdateUserOfExistingOrder) {
                      this.toggleOrderType();
                    }
                  }
                  return;
                } else if(resp.data=== ""|| resp.data === null){
                  this.clearPageAndDisplayNoOrderExistMsg();
                } else {
                  if (this.order.customerAddressesByCustomerAddressId.areasByAreaId.id === this.$store.state.takeAwayAddressId) {
                      if(parseInt(this.orderTypeId) === 3 && this.newOrderType !== 7) {
                          swal("Error!", " Please Add/Select Address First", "warning");
                      }
                  } else {
                    swal("Warning!", "If you're changing the order type, select your branch", "warning");
                  }
                }
                await this.load(resp.data);
                this.isHideSpinner = "hide";
              });
            },
            selectCustomer: async function(customerId){
                let params= new URLSearchParams();
                params.append("caller_number", this.callerNumber);
                params.append("uan", this.uan);
                params.append("customer_id", customerId);
                let resp= await this.$http.post(this.$store.state.mainAppURL + "orders/create_order_and_set_customer", params);
                this.createOrder();
                $("#chooseCustomerModal").modal("hide");
            },
            updateOrderSource: async function () {
              let params = new URLSearchParams()
              params.append('caller_number', this.callerNumber);
              params.append('source', this.newOrderType);
              this.$http.post(this.$store.state.mainAppURL + "orders/update_order_source", params).then(resp => {
                  if (!resp.data) {
                      this.clearPageAndDisplayNoOrderExistMsg();
                  }else{
                    if(!this.order.orderSource) {
                      this.order.orderSource = {
                        "id": this.newOrderType
                      }
                    }
                  }
              });
            },
            togglePaymentMethod: async function(){
                let params= new URLSearchParams();
                params.append("caller_number", this.callerNumber);
                params.append("payment_method_id", this.order.paymentMethod.id);
                let resp= await this.$http.post(this.$store.state.mainAppURL + "orders/toggle_payment_method", params);
                if(resp.data === ''){
                  this.clearPageAndDisplayNoOrderExistMsg();
                }else {
                  this.order = resp.data;
                }
            },
            changePaymentStatus: async function(){
                let params= new URLSearchParams();
                params.append("caller_number", this.callerNumber);
                params.append("payment_status_id", this.order.paymentStatus.id);
                let resp = await this.$http.post(this.$store.state.mainAppURL + "orders/change_payment_status", params);
                if (resp.data === '') {
                  this.clearPageAndDisplayNoOrderExistMsg();
                }
            },
            getAllPaymentMethods: function(){
                this.$http.get(this.$store.state.mainAppURL + "orders/get_all_payment_method").then(resp=>{
                    this.allPaymentMethods= resp.data;
                })
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.c2d_cont_1{
    height: 205px !important;
    overflow: auto;
}
.blocking_overlay{
    position: absolute;
    display: block;
    width: 96%;
    height: 100%;
    top: 2px;
    left: 12px;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 2;
    cursor: not-allowed;
    opacity: 0.75;
}
.blocking_overlay i{
    font-size: 125px;
    line-height: 1.85;
    color: #f9204b;
}
.hideTableBottom > tbody > tr > td{
    border-top: 0 !important;
}
.cart_table > tbody > tr > td{
    padding: 5px;
    white-space: nowrap;
}
.increaseLineHeight{
    line-height: 2;
}

.spinner {
    width: 100px;
}
.spinner input {
    text-align: right;
}
.input-group-btn-vertical {
    position: relative;
    white-space: nowrap;
    width: 1%;
    vertical-align: middle;
    display: table-cell;
}
.input-group-btn-vertical > .btn {
    display: block;
    float: none;
    width: 100%;
    max-width: 100%;
    padding: 8px;
    margin-left: -1px;
    position: relative;
    border-radius: 0;
}
.input-group-btn-vertical > .btn:first-child {
    border-top-right-radius: 4px;
}
.input-group-btn-vertical > .btn:last-child {
    margin-top: -2px;
    border-bottom-right-radius: 4px;
}
.input-group-btn-vertical i{
    position: absolute;
    top: 0;
    left: 4px;
}
#complaint_alert{
    width: 27%;
    position: fixed;
    bottom: 0;
    right: 42px;
}
.list-group-item{
    padding: 5px 15px !important;
}
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9{
    padding-right: 4px !important;
    padding-left: 4px !important;
}
    .instruction_text{
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /*.menu-categories-ul li{*/
        /*border: solid 1px #1a7bb9;*/
    /*}*/
.delivery-custom-btn{
    width: 100%;
    outline: none;
}

.delivery-custom-btn-div button:hover{
    border: 1px solid #dfdfdf;
    background-color: #f8ac59;
}
.width-150 {
  width: 150px;
}
</style>
